import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => (
  <div>
    <h2>Page Not Found</h2>
    <div>
      <Link to="/">Home</Link>
    </div>
    <p>You&apos;ve reached a non-existant page.</p>
  </div>
);

export default NotFound;
